var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 h-100 w-100 d-flex flex-column align-items-center"},[_c('div',{staticClass:"w-100",staticStyle:{"height":"calc(100vh - 3.125rem) !important"}},[_c('div',{staticClass:"blank-layout-style flex-fill"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }